import React from 'react';

const REASON_TEXT = {
    stall: {
        title: 'Видео часто подтормаживает',
        text: 'Похоже, с этим источником сейчас плохо. Другой плеер может работать стабильнее.',
    },
    error: {
        title: 'Не удаётся воспроизвести',
        text: 'Этот источник не отвечает. Попробуйте открыть серию в другом плеере.',
    },
};

/**
 * Non-blocking card inside the player that offers to switch to another source.
 * `options` are the other available players: [{ mode, label }].
 */
const PlayerSwitchHint = ({ reason = 'stall', options = [], onSwitch, onDismiss }) => {
    if (!options.length) return null;
    const copy = REASON_TEXT[reason] || REASON_TEXT.stall;
    return (
        <div className={`player-switch-hint is-${reason}`} role="status" aria-live="polite">
            <div className="player-switch-hint__text">
                <strong>{copy.title}</strong>
                <span>{copy.text}</span>
            </div>
            <div className="player-switch-hint__actions">
                {options.map((option) => (
                    <button
                        key={option.mode}
                        type="button"
                        className="ui-btn ui-btn--light ui-btn--sm"
                        onClick={() => onSwitch?.(option.mode)}
                    >
                        {option.label}
                    </button>
                ))}
                <button type="button" className="ui-btn ui-btn--ghost ui-btn--sm" onClick={onDismiss}>
                    Не сейчас
                </button>
            </div>
        </div>
    );
};

export default PlayerSwitchHint;
